import React, { Component } from 'react'
import {
	Message,
	Billed,
	BoxBill,
	NavigationContainer,
	ArrowButton,
	CreditValue
} from './bill.style'
import {
	navigationOperationConstants,
	monthConstants
} from '../../../../../../constants'
class Bill extends Component {
	constructor(props) {
		super(props)
	}

	renderNavigationContainer = partialValue => {
		const { onChangeCompetence } = this.props
		const zeroValue = 0
		const creditValue = partialValue && partialValue < 0 ? (partialValue * (-1)) : zeroValue;
		return (
			<NavigationContainer>
				<ArrowButton
					onClick={() => {
						onChangeCompetence(navigationOperationConstants.PREVIOUS)
					}}>
					<div className="arrow mirrored"></div>
				</ArrowButton>
				<Billed>
					<sup>{partialValue ? '*' : ''}</sup>
					{partialValue && partialValue > 0 ? partialValue.$toReais() : zeroValue.$toReais()}
				</Billed>

				<ArrowButton
					onClick={() => {
						onChangeCompetence(navigationOperationConstants.NEXT)
					}}>
					<div className="arrow"></div>
				</ArrowButton>
			</NavigationContainer>
		)
	}

	render() {
		const {
			status,
			closingDate,
			partialValue,
			invoiceExists,
			expirationDate,
			selectedCompetence
		} = this.props
		const competenceMonth = selectedCompetence.substring(4, 6)
		const competenceYear = selectedCompetence.substring(0, 4)
		const monthLabel = `${monthConstants.find(month => month.number === competenceMonth).label}/${competenceYear}`
		const zeroValue = 0
		const creditValue = partialValue && partialValue < 0 ? (partialValue * (-1)) : zeroValue;
		return (
			<BoxBill>
				{creditValue > 0 && (
					<CreditValue>
						Crédito: {creditValue.$toReais()}
					</CreditValue>
				)}
				{invoiceExists ? (
					<React.Fragment>
						<Message className="orange">Fatura {monthLabel}</Message>
						{this.renderNavigationContainer(partialValue)}
						<Message className="white">Fatura {status}</Message>
						<Message className="white">
							Vencimento: {expirationDate}
						</Message>
						<Message className="white">Fechamento: {closingDate}</Message>
					</React.Fragment>
				) : (
						<React.Fragment>
							<Message className="orange">
								Não há faturas para {monthLabel}
							</Message>
							{this.renderNavigationContainer(partialValue)}
						</React.Fragment>
					)}
			</BoxBill>
		)
	}
}

export default Bill
